/** @jsxImportSource theme-ui */
import { Container, Box, Flex, Heading } from 'theme-ui';
import Customers from '@/containers/customers/Customers';

const CustomersPage = () => {
    return (
        <Container>
            <Flex sx={{ flexDirection: 'column', gap: 2 }}>
                <Heading as="h2">Customers</Heading>
                <Box
                    sx={{
                        borderRadius: 'sm',
                        backgroundColor: 'background',
                        padding: 2,
                    }}
                >
                    <Customers />
                </Box>
            </Flex>
        </Container>
    );
};

export default CustomersPage;
